module.exports = __webpack_public_path__ + "img/SEFE_120X35.fe71ce60.png";